export default __webpack_public_path__ + "static/media/error.d7982a22.png";